import { WireframeTrianglesScene } from './WireframeTrianglesScene';

let headerScene: any;

window.onload = () => {
  const headerContainer = document.getElementById('gl-header');
  headerScene = new WireframeTrianglesScene( window.innerWidth, 240, headerContainer );
  headerScene.animate();
};
